import { ILatLon, MapPoint } from '@curbnturf/objects';

export const searchSort = (rowA: MapPoint, rowB: MapPoint) => {
  if (
    (rowA.photos?.length > 0 && rowB.photos?.length > 0) ||
    (rowA.photos?.length === 0 && rowB.photos?.length === 0)
  ) {
    if (rowA.distance && rowB.distance) {
      return rowA.distance - rowB.distance;
    }

    if (!rowA.distance) {
      return -1;
    }

    if (!rowB.distance) {
      return 1;
    }

    return 0;
  }

  // sites with photos should be before sites without
  return rowA.photos.length > 0 ? -1 : 1;
};

export function pointInBox(point: MapPoint, southeast?: ILatLon, northwest?: ILatLon): boolean {
  // if we don't have lat/lon for the corners, we can't filter by location, so return true
  if (!southeast || !northwest) {
    return true;
  }

  if (
    (southeast.lat || southeast.lat === 0) &&
    (northwest.lat || northwest.lat === 0) &&
    (southeast.lon || southeast.lon === 0) &&
    (northwest.lon || northwest.lon === 0)
  ) {
    return (
      point.coordinates?.lat <= northwest.lat &&
      point.coordinates?.lat >= southeast.lat &&
      point.coordinates?.lon >= northwest.lon &&
      point.coordinates?.lon <= southeast.lon
    );
  }

  // if lat/lon were not set for the corners, we can't filter by location, so return true
  return true;
}
